var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("page-outline", {
    attrs: { title: _vm.$t("Webheader.usercompany") },
    scopedSlots: _vm._u([
      {
        key: "pageContent",
        fn: function () {
          return [
            _c(
              "b-container",
              { attrs: { fluid: "" } },
              [
                _c(
                  "b-col",
                  {
                    staticClass: "d-flex justify-content-end mt-3",
                    attrs: { cols: "12" },
                  },
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "btnFilter_2 mr-2",
                        attrs: {
                          variant: "primary",
                          disabled: !_vm.canAddUser,
                        },
                        on: { click: _vm.addUser },
                      },
                      [
                        _c("i", { staticClass: "fa-light fa-plus" }),
                        _vm._v(" "),
                        _c("span", { staticClass: "fab-label" }, [
                          _vm._v(_vm._s(_vm.$t("administration.user_add"))),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-button",
                      {
                        staticClass: "btnFilter_2 mr-2",
                        on: {
                          click: function ($event) {
                            _vm.displayFilter = !_vm.displayFilter
                          },
                        },
                      },
                      [
                        _vm.displayFilter
                          ? _c("i", { staticClass: "fa-light fa-minus" })
                          : _c("i", { staticClass: "fa-light fa-plus" }),
                        _vm._v(
                          "\n  \t\t\t\t" +
                            _vm._s(_vm.$t("filter.fltr")) +
                            "\n  \t\t\t  "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-button",
                      {
                        staticClass: "btnFilter_2",
                        on: {
                          click: function ($event) {
                            return _vm.refreshInbox()
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "fa-light fa-rotate-right" }),
                        _vm._v(
                          "\n  \t\t\t\t" +
                            _vm._s(_vm.$t("common.rfrsh")) +
                            "\n  \t\t\t  "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("hr", { staticClass: "mx-auto" }),
                _vm._v(" "),
                _vm.displayFilter
                  ? _c(
                      "b-row",
                      {
                        staticClass:
                          "min-w-100 justify-content-start align-items-center",
                      },
                      [
                        _c(
                          "b-col",
                          {
                            staticClass: "filter-item mb-3",
                            attrs: { sm: "6", lg: "3", cols: "12" },
                          },
                          [
                            _c("span", { staticClass: "filter-item-title" }, [
                              _vm._v(
                                "\n  \t\t\t\t\t" +
                                  _vm._s(_vm.$t("administration.company")) +
                                  "\n  \t\t\t\t  "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "filter-item-content" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.nameCompany,
                                    expression: "nameCompany",
                                  },
                                ],
                                class: {
                                  "filter-item-input": true,
                                  "filter-item-input-complete": _vm.nameCompany,
                                },
                                attrs: {
                                  type: "text",
                                  placeholder: _vm.$t(
                                    "administration.company_name"
                                  ),
                                },
                                domProps: { value: _vm.nameCompany },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.nameCompany = $event.target.value
                                  },
                                },
                              }),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          {
                            staticClass: "filter-item mb-3",
                            attrs: { sm: "6", lg: "3", cols: "12" },
                          },
                          [
                            _c("span", { staticClass: "filter-item-title" }, [
                              _vm._v(_vm._s(_vm.$t("administration.login"))),
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "filter-item-content" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.login,
                                    expression: "login",
                                  },
                                ],
                                class: {
                                  "filter-item-input": true,
                                  "filter-item-input-complete": _vm.login,
                                },
                                attrs: {
                                  type: "text",
                                  placeholder: _vm.$t("administration.login"),
                                },
                                domProps: { value: _vm.login },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.login = $event.target.value
                                  },
                                },
                              }),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          {
                            staticClass: "filter-item mb-3",
                            attrs: { sm: "6", lg: "3", cols: "8" },
                          },
                          [
                            _c("span", { staticClass: "filter-item-title" }, [
                              _vm._v(_vm._s(_vm.$t("administration.active"))),
                            ]),
                            _vm._v(" "),
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.userActive,
                                    expression: "userActive",
                                  },
                                ],
                                ref: "selectDoctype",
                                staticClass: "filter-item-content w-100",
                                on: {
                                  change: function ($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call(
                                        $event.target.options,
                                        function (o) {
                                          return o.selected
                                        }
                                      )
                                      .map(function (o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.userActive = $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  },
                                },
                              },
                              [
                                _vm._v('">\n  \t\t\t\t\t  '),
                                _c("option", { attrs: { value: "" } }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("administration.select_activity")
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "0" } }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$t("administration.no")) +
                                      " "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "2" } }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$t("administration.yes")) +
                                      " "
                                  ),
                                ]),
                              ]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          {
                            staticClass:
                              "min-w-100 justify-content-end align-items-center",
                          },
                          [
                            _c(
                              "b-col",
                              {
                                staticClass: "d-flex justify-content-end mt-3",
                                attrs: { cols: "12" },
                              },
                              [
                                _c(
                                  "b-button",
                                  {
                                    staticClass: "btnFilter_2 mr-2",
                                    attrs: { disabled: !_vm.hasInputFilter },
                                    on: { click: _vm.clearFilterFields },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("common.rst")))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-button",
                                  {
                                    staticClass: "btnFilter_2",
                                    on: {
                                      click: function ($event) {
                                        return _vm.applyFilter()
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("common.srch")))]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.displayFilter
                  ? _c("hr", { staticClass: "mx-auto mb-4" })
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      { staticClass: "mx-auto mb-4", attrs: { cols: "12" } },
                      [
                        _c(
                          "div",
                          { staticStyle: { overflow: "auto" } },
                          [
                            _vm.activateSpinner
                              ? _c("spinner")
                              : _vm.UsersList.length > 0
                              ? _c("b-table", {
                                  staticClass: "table table-striped",
                                  attrs: {
                                    hover: "",
                                    fields: _vm.fields,
                                    items: _vm.UsersList,
                                    selectable: _vm.UsersList.length > 0,
                                    "empty-text": "Pas de résultat",
                                  },
                                  on: { "row-selected": _vm.seeUserDetails },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "cell(Name)",
                                      fn: function (data) {
                                        return [
                                          !data.value
                                            ? _c("span", [_vm._v("-")])
                                            : _c("span", [
                                                _vm._v(_vm._s(data.value)),
                                              ]),
                                        ]
                                      },
                                    },
                                    {
                                      key: "cell(Active)",
                                      fn: function (data) {
                                        return [
                                          data.value == 0
                                            ? _c("i", {
                                                staticClass:
                                                  "fa-light fa-xmark btn btn-icon btn-icon-red",
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          data.value == 2
                                            ? _c("i", {
                                                staticClass:
                                                  "fa-light fa-check btn btn-icon btn-icon-green",
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          data.value == 1
                                            ? _c("i", {
                                                staticClass:
                                                  "fa-light fa-warning btn btn-icon btn-icon-orange",
                                              })
                                            : _vm._e(),
                                        ]
                                      },
                                    },
                                    {
                                      key: "cell(edit)",
                                      fn: function (data) {
                                        return [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "text-center d-inline-block py-4 w-100",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.activateEdit(data)
                                                },
                                              },
                                            },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "fa-regular fa-pencil",
                                              }),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                    {
                                      key: "cell(delete)",
                                      fn: function (data) {
                                        return [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "text-center d-inline-block py-4 w-100",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.activateDelete(
                                                    $event,
                                                    data.value
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "fa-light fa-trash",
                                              }),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("span", [
                                            _vm._v(_vm._s(data.value.IdUser)),
                                          ]),
                                        ]
                                      },
                                    },
                                  ]),
                                })
                              : _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex justify-content-center",
                                  },
                                  [
                                    _c("span", { staticClass: "noResult" }, [
                                      _vm._v(
                                        "\n  \t\t\t\t\t\t  " +
                                          _vm._s(_vm.$t("common.no_result")) +
                                          "\n  \t\t\t\t\t\t"
                                      ),
                                    ]),
                                  ]
                                ),
                          ],
                          1
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }